// extracted by mini-css-extract-plugin
module.exports = {"recaptcha":"ContactForm__recaptcha__rI-rY","sendBtn":"ContactForm__sendBtn__3kwWI","space":"ContactForm__space__lbbof","formMessage":"ContactForm__formMessage__15yHR"};